import {create} from "zustand";


interface AuthState {
    idToken: string | null;
    tokenReady: boolean;
    payload: Record<string, any> | null
}

export const useAuthStore = create<AuthState>(() => ({
    idToken: null,
    tokenReady: false,
    payload: null,
}));
